/**
 * Compte à rebours de réservation du panier (urgence).
 * - Persistant via localStorage : le décompte reste continu entre reloads et
 *   re-renders de section (morph). Il ne repart de zéro qu'à l'expiration ou
 *   quand le panier est vidé.
 * - Optionnellement, vide le panier à l'expiration.
 */
const STORAGE_KEY = 'cart_reservation_end';

class CartReservationTimer extends HTMLElement {
  #interval = null;

  connectedCallback() {
    this.display = this.querySelector('[data-ref="display"]');
    this.minutes = parseInt(this.dataset.minutes, 10) || 10;
    this.template = this.dataset.text || '[time]';
    this.expiredText = this.dataset.expired || '';
    this.clearOnExpire = this.dataset.clearOnExpire === 'true';

    this.endTime = this.#resolveEndTime();
    this.#tick();
    this.#interval = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    if (this.#interval) clearInterval(this.#interval);
  }

  #resolveEndTime() {
    const now = Date.now();
    let stored = null;
    try {
      stored = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    } catch (e) {
      stored = null;
    }
    if (!stored || Number.isNaN(stored) || stored <= now) {
      const end = now + this.minutes * 60 * 1000;
      try {
        localStorage.setItem(STORAGE_KEY, String(end));
      } catch (e) {
        /* stockage indisponible : décompte valable pour cette page uniquement */
      }
      return end;
    }
    return stored;
  }

  #tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      this.#onExpire();
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const mm = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const ss = String(totalSeconds % 60).padStart(2, '0');
    if (this.display) {
      this.display.innerHTML = this.template.replace(
        '[time]',
        `<strong class="cart-reservation-timer__time">${mm}:${ss}</strong>`
      );
    }
  }

  #onExpire() {
    if (this.#interval) clearInterval(this.#interval);
    if (this.display) this.display.textContent = this.expiredText;
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* noop */
    }

    if (this.clearOnExpire) {
      fetch(`${Theme.routes.cart_url || '/cart'}/clear.js`, { method: 'POST' })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {});
    }
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}
